import React, { useEffect, useState } from "react";
import { Card, ListGroup } from "react-bootstrap";
import { MoreVertical } from "lucide-react";
import './TopEvent.css'
import { MdEventAvailable } from "react-icons/md";
import { FaRegClock } from "react-icons/fa6";
import axios from "axios";



// const users = [
//     {
//         name: "Michael Jordan",
//         email: "michael.jordan@example.com",
//         amount: "$2,893",
//         avatar: "https://i.pravatar.cc/50?img=3",
//         bgColor: "primary",
//     },
//     {
//         name: "Emigo Kiaren",
//         email: "emigo.kiaren@gmail.com",
//         amount: "$4,289",
//         avatar: null,
//         bgColor: "warning",
//     },
//     {
//         name: "Randy Origoan",
//         email: "randy.origoan@gmail.com",
//         amount: "$6,347",
//         avatar: "https://i.pravatar.cc/50?img=5",
//         bgColor: "secondary",
//     },
//     {
//         name: "George Pieterson",
//         email: "george.pieterson@gmail.com",
//         amount: "$3,894",
//         avatar: null,
//         bgColor: "success",
//     },
//     {
//         name: "Kiara Advain",
//         email: "kiaraadvain214@gmail.com",
//         amount: "$2,679",
//         avatar: null,
//         bgColor: "info",
//     },
// ];



const TopDeals = () => {
    const [hosts, setHosts] = useState([]); // State to store API data

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://ridehire-backend-2.onrender.com/host/topFive");
                console.log(response.data);

                setHosts(response.data); // Assuming the API returns an array of hosts
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData(); // Fetch data once when the component mounts
    }, []);
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { year: "numeric", month: "short", day: "numeric" };
        const formattedDate = date.toLocaleDateString("en-US", options);
        const weekday = date.toLocaleDateString("en-US", { weekday: "short" });
        return `${formattedDate} (${weekday})`;
    };

    // Function to format time in "7:26 pm" format
    const formatTime = (timeString) => {
        return new Date(timeString).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true
        });
    };

    return (
        <Card className="shadow rounded-xl p-2 mx-auto" style={{ maxWidth: "100%" }}>
            {/* Header */}
            <Card.Header className="d-flex justify-content-between align-items-center border-bottom p-1 mt-2">
                <h5 className="mb-0">
                    <span className="border-start border-primary ps-2">Top Deals</span>
                </h5>
                <MoreVertical className="text-secondary cursor-pointer" />
            </Card.Header>

            {/* Scrollable User List */}
            <div className="scrollable-list">
                <ListGroup variant="flush">
                    {hosts.map((host, index) => (
                        <div className="card border-0 mt-3 date-time p-1" key={index}>
                            <div className="d-flex justify-content-between">
                                <div className="price d-flex gap-2">
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="tPrice h6 m-0">{host.price}</div>
                                        <img
                                            src={host.hostData.host_img ? `https://ridehire-backend-2.onrender.com${host.hostData.host_img}` : "https://via.placeholder.com/50"}
                                            className="host-img img-content"
                                            alt="Event"
                                        />
                                        <div className="img-content w-100 host_name">{host.hostData.host_fName} {host.hostData.host_lName}</div>
                                    </div>
                                </div>
                                <div className="id">{host.event_id}</div>
                            </div>
                            <div className="d-flex mt-2">
                                <img
                                    src={host.hostData.host_img ? `https://ridehire-backend-2.onrender.com${host.hostData.host_img}` : "https://via.placeholder.com/50"}
                                    alt="" className="host-img1 rounded-circle img-content1"
                                />
                                <div className="ms-2 img-content1">{host.hostData.host_fName} {host.hostData.host_lName}</div>
                            </div>
                            <h6 className="">{host.event_name}</h6>
                            <div className="d-flex align-items-center gap-2 dateTime">
                                <MdEventAvailable />
                                <div>{formatDate(host.departureStartTime)}</div>
                                <FaRegClock />
                                <div>{`${formatTime(host.departureStartTime)} - ${formatTime(host.departureEndTime)}`}</div>
                            </div>
                        </div>
                    ))}
                </ListGroup>
            </div>
        </Card>


    );
};

export default TopDeals;
